<!--
     <NumericInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value: Gives the field's serializable value

     Accepted props:
     - size
     - value
     - label
     - class
     - min
     - max
     - decimals (0: integer)
-->
<template>
  <v-text-field
    :key="reload"
    :value="input"
    :size="props.size"
    :label="props.label"
    :class="[
      props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input',
      { required: props.required }
    ]"
    :placeholder="props.placeholder"
    :readonly="props.readonly"
    @click:append="increment"
    @click:prepend="decrement"
    outlined
    dense
    @change="update_value"
    background-color="#f2f2f2"
    :disabled="!!props.disabled || !!props.readonly"
    :rules="[only_nums, is_required, is_in_range, is_integer]"
    @update:error	="error_state"
  >
    <template slot="append-outer" v-if="((!props.readonly && !props.disabled) && !props.hidde_icons)">
      <v-icon
        @click="increment"
        color="primary"
        :disabled="props.readonly || props.disabled"
      >
        {{ false || 'mdi-plus' }}
      </v-icon>
    </template>
    <template slot="prepend" v-if="((!props.readonly && !props.disabled) && !props.hidde_icons)">
      <v-icon
        color="primary"
        @click="decrement"
        :disabled="props.readonly || props.disabled"
      >
        {{ false || 'mdi-minus' }}
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'NumericInput',

  props: ['props'],

  data: () => ({
    valid: true,
    reload: false,
  }),

  mounted() {
  },

  computed: {
    input() {
      if (this.props.value == null) return null  // Sets empty input
      return this.parse_value(this.props.value)
    },
    value() {
      if (this.props.value != null)
        return this.parse_value(this.props.value)
      return this.props.value
    },
  },

  methods: {
    increment() {
      this.update_value(
        this.parse_value(this.props.value) + Math.pow(10, -this.decimals || 0),
      )
    },

    decrement() {
      this.update_value(
        this.parse_value(this.props.value) - Math.pow(10, -this.decimals || 0),
      )
    },

    enforce_min_max(value) {
      if (value && value < this.props.min) {
        return this.props.min
      } else if (this.props.max && value > this.props.max) {
        this.props.max
      }
      return value
    },

    parse_value(value) {
      // Transforms val to numeric with props.decimals precision
      if (!this.valid) {
        return value;
      }
      var val = +(''+(value||'0')).replace(/[_  ]/g, '').replace(/[,、]/g, '.');
      if (this.props.decimals){
        return parseFloat(""+(parseFloat(val)).toFixed(this.props.decimals))
      }
      return parseInt(val)
    },
    update_value(value) {
      if (this.valid) {
        this.reload = !this.reload;
        this.$emit('update',this.parse_value(value));
      }
    },
    validate() {
      return (
        this.props.value >= this.props.min && this.props.value <= this.props.max
      )
    },
    error_state(value) {
      this.valid = !value;
    },

    // Validate functions
    is_required(value) {
      if (value === 0) return true
      return !!value || !this.props.required || this.$vuetify.lang.translator('required_field')
    },
    is_in_range(value) {
      if (!value && value !== 0){
        return true;
      }
      value = +(''+(value||'0')).replace(/[_  ]/g, '').replace(/[,、]/g, '.');
      let v = true
      if (this.props.min === 0 || this.props.min) {
        v =
          value >= this.props.min ||
          this.$vuetify.lang.translator('bigger_than') + ' ' + (this.props.min - 1)
      }
      if (v === true && (this.props.max === 0 || this.props.max)){
        v =
          value <= this.props.max ||
          this.$vuetify.lang.translator('smaller_than') + ' ' + (this.props.max + 1)
      }
      return v || this.$vuetify.lang.translator('invalid_value')
    },
    only_nums(value) {
      value = +(''+(value||'0')).replace(/[_  ]/g, '').replace(/[,、]/g, '.');
      return !isNaN(value) || this.$vuetify.lang.translator('invalid_value')
    },

    is_integer(value) {
      return !!this.props.decimals || !!Number.isInteger(Number(value))  || this.$vuetify.lang.translator('invalid_value')
    },
  },

  // watch: {
  //   props(p) {
  //     // console.log('NumericInput.watch.props(', JSON.stringify(p), ')')
  //     this.input = p.value
  //   },
  // },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
